import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { MainsmsComponent } from "./Automation/mainsms/mainsms.component";
import { TemplatesmsComponent } from "./Automation/templatesms/templatesms.component";
import { ClientbaseComponent } from "./Customers/clientbase/clientbase.component";
import { CanDeactivateGuardService } from "./services/Common/can-deactivate-guard.service";
import { CustcardEditpersonalComponent } from "./Customers/custcard-editpersonal/custcard-editpersonal.component";
import { CustcardComponent } from './Customers/custcard/custcard.component';
import { CalendarviewComponent } from "./Diary/calendarview/calendarview.component";
import { CalendarbaseComponent } from "./Diary/calendarbase/calendarbase.component";
//import {ActiveworkersComponent} from "./Diary/activeworkers/activeworkers.component";

const routes: Routes = [
    { path: "login", component: HomeComponent },
    { path: "mainsms", component: MainsmsComponent },
    {
        path: "mainsms", children: [
            { path: "template", component: TemplatesmsComponent, canDeactivate: [CanDeactivateGuardService] },
        ]
    },
    { path: "clients", component: ClientbaseComponent },
    {
        path: "clients",
        children: [
            { path: "editpersonal/:id", component: CustcardEditpersonalComponent, canDeactivate: [CanDeactivateGuardService] },
            { path: "editpersonal", component: CustcardEditpersonalComponent, canDeactivate: [CanDeactivateGuardService] },
            { path: "custcardview/:id", component: CustcardComponent, canDeactivate: [CanDeactivateGuardService] }
        ],
    },

    { path: "diary", component: CalendarbaseComponent },

    {
        path: "diary",
        children: [
            { path: "calendarview/:id", component: CalendarviewComponent, canDeactivate: [CanDeactivateGuardService] },
           // { path: "activeworkers/:id", component: ActiveworkersComponent, canDeactivate: [CanDeactivateGuardService] }
        ],
    },


    { path: "module2", redirectTo: "/diary", pathMatch: "full" },
    { path: "module3", redirectTo: "/clients", pathMatch: "full" },
    { path: "module8", redirectTo: "/mainsms", pathMatch: "full" },
    { path: "**", redirectTo: "/login", pathMatch: "full" },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [CanDeactivateGuardService],
})
export class AppRoutingModule { }
